import React, { Component, Fragment } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { APPLICATIONS_SUPPORT_EMAIL } from '../../constants/emails';
import { CUSTOMER_SUPPORT_MESSAGE } from '../../constants/messages';

import { Banner, Spinner } from '@zillow/constellation';

export default class LoadingScreen extends Component {
  static propTypes = {
    show: PropTypes.bool,
    showSpinner: PropTypes.bool,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    message: PropTypes.string,
    className: PropTypes.string,
    showCustomerSupportMessage: PropTypes.bool,
  };

  static defaultProps = {
    show: false,
    showSpinner: false,
    isError: false,
    isLoading: false,
    message: '',
    className: '',
    showCustomerSupportMessage: false,
  };

  renderCustomerSupportMessage() {
    if (this.props.showCustomerSupportMessage) {
      const emailHref = 'mailto:' + APPLICATIONS_SUPPORT_EMAIL;
      return (
        <Fragment>
          {CUSTOMER_SUPPORT_MESSAGE}
          <a href={emailHref}>{APPLICATIONS_SUPPORT_EMAIL}</a>.
        </Fragment>
      );
    }
    return '';
  }

  render() {
    const { className, message, isError, showSpinner, show, isLoading } = this.props;
    const customerSupportMessage = this.renderCustomerSupportMessage();

    return (
      (show || isLoading) && (
        <section className={cx('rental-application__loading-screen', className)}>
          {showSpinner || isLoading ? (
            <Spinner size="md" />
          ) : (
            <Banner appearance={isError ? 'error' : 'info'} body={`${message}${customerSupportMessage}`} />
          )}
        </section>
      )
    );
  }
}
